import { DeepPartial, DEFAULT_EMPATHIZE_LAYOUT_CONFIG, EmpathizeConfig, EmpathizeLayoutItem, EVENTS } from '@empathybroker/ebx-gluon';

export const MOBILE_EMPATHIZE: DeepPartial<EmpathizeConfig> = {
  layout: {
    noQuery: [
      [{ ...DEFAULT_EMPATHIZE_LAYOUT_CONFIG.queryHistory, showWhenEmpty: true }],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.nextQueriesSuggestions],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.popularSearches],
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.resultsSuggestions]
    ],
    query: [
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.suggestions]
    ]
  }
};
